import React from 'react'
import { string } from 'prop-types'
import styled from '@emotion/styled'

const GrayP = styled.p`
  color: ${({ theme }) => theme.colors.gray};
`

const GrayHR = styled.hr`
  border-color-top: ${({ theme }) => theme.colors.gray};
`

const Section = ({ title }) => (
  <>
    <GrayP>{title}</GrayP>
    <GrayHR />
  </>
)

Section.propTypes = {
  title: string,
}

Section.defaultProps = {
  title: null,
}

export default Section
